import React, { Component } from 'react';
import { Switch, Route, withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Parser from './NlpDemo';
import $ from 'jquery';

class NlpDemoTab extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/platform/cloud-nlp/demo";
      var path1 = window.origin + "/platform/cloud-nlp/demo";
      if (currentPath === path || currentPath === path1) {
        $("#parse-tab").addClass('active');
      // } else if (currentPath.includes("/cloud-nlp/demo/spellCheck") || currentPath.includes("/cloud-nlp/demo/spellCheck/")) {
      //   $("#spellCheck-tab").addClass('active');
      }
      else {
        $("#" + localStorage.getItem("last-project-settings-tab")).addClass('active')
      }
      $("#parse-tab,#spellCheck-tab")
        .on("click", function () {
          $("#parse-tab,#spellCheck-tab")
            .removeClass('active');
          localStorage.setItem("last-project-settings-tab", $(this)[0].id);

          $(this).addClass('active')

        })


    })();
  }
  render() {
    return (

      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <div className="content-header" >
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5">
                  <h1 className="m-0 page-title">Demo</h1>
                  <h6 className="taglineTxt"></h6>
                </div>

              </div>
            </div>
          </div>
          <div className="container-fluid" >
          <div className="border-bottom"></div>

            {/* Nav tabs */}
            <div className="d-flex p-0 border-bottom">

              <ul className="nav nav-pills mr-auto" >
                <Link to="/cloud-nlp/demo" style={{ textDecoration: 'none' }}>

                  <li className="nav-item">
                    <a className="nav-link" id="parse-tab">Vibhakthi Parser</a>
                  </li></Link>

                {/* <Link to="/cloud-nlp/demo/spellCheck" style={{ textDecoration: 'none' }}>
                  <li className="nav-item">
                    <a className="nav-link" id="spellCheck-tab">Spell Check</a>
                  </li>
                </Link> */}

              </ul>
            </div>
          </div>
        </div>
        <Switch>
          {/* <Route path="/cloud-nlp/demo/spellCheck" component={spellCheck}></Route> */}
          <Route path="/cloud-nlp/demo" component={Parser}></Route>
        </Switch>
      </div>

    );
  }
}
export default NlpDemoTab;


// WEBPACK FOOTER //
// ./src/nlpUi/NlpDemoTabs.js